import wos from 'apis/wos';
import cart, { getCartGuidHeader, setCartGuidHeader } from 'apis/cart';

import type { Project, ProjectSaveParams } from './projects.types';
import type { PickRequired } from 'types/common_types';

export const all = async () => {
  const resp = await wos.get<Project[]>('/projects.json');
  return resp.data;
};

/** Returns the string for the source cart guid to restore  */
export const create = async (project: ProjectSaveParams) => {
  const resp = await cart.post<string>('/projects', project);
  return resp.data;
};

export const update = async (project: PickRequired<ProjectSaveParams, 'guid'>) => {
  const previousGuid = getCartGuidHeader();
  if (!previousGuid) throw new Error('No Cart Guid Header');

  setCartGuidHeader(project.guid);
  const response = await cart.patch<Project>('/projects', project);
  setCartGuidHeader(previousGuid);

  return response.data;
};

export const destroy = async (guid: string) => {
  const previousGuid = getCartGuidHeader();

  setCartGuidHeader(guid);
  await cart.delete(`/projects`);
  setCartGuidHeader(previousGuid);
};

/** Sets the cart guid header for the global cart API to the restored cart  */
export const restore = async (guid: string) => {
  setCartGuidHeader(guid);
  const resp = await cart.post<{ guid: string }>('/projects/restore');
  setCartGuidHeader(resp.data.guid);
};
